import { HttpContextToken } from '@angular/common/http';

export const SUCCESS_TOAST = new HttpContextToken<string | null>(() => null);

export const SHOW_ERROR_TOAST = new HttpContextToken<boolean>(() => false);